import * as rd from '@devexperts/remote-data-ts'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '@/hooks/store'
import { appSlice } from '@/store/appSlice'
import { cartSlice } from '@/store/cartSlice'
import { licenseSlice } from '@/store/licenseSlice'
import { REG_ID_QUERY_PARAM_NAME } from '@/utils/constants'
import { openReservationSummary } from '@/utils/openReservationSummary'

export const ReservationSummaryRoute = () => {
  const [searchParams] = useSearchParams()
  const { i18n } = useTranslation()
  const dispatch = useAppDispatch()
  const cartDetail = useAppSelector(cartSlice.selectors.cartDetail)
  const license = useAppSelector(licenseSlice.selectors.licenseCode)
  const country = useAppSelector(appSlice.selectors.country)

  useEffect(() => {
    const reservationId = searchParams.get(REG_ID_QUERY_PARAM_NAME)
    if (reservationId) {
      dispatch(cartSlice.actions.getCartDetail({ reservationId }))
    }
  }, [])

  useEffect(() => {
    if (!rd.isSuccess(cartDetail)) {
      return
    }
    openReservationSummary({
      cartDetail: cartDetail.value,
      country,
      lang: i18n.language,
      licenseCode: license,
      searchParams: searchParams,
      target: '_self',
    })
  }, [cartDetail])
  return null
}
